import { Col, Row } from 'react-bootstrap';
import '../Global.css';
import Card from 'react-bootstrap/Card';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../components/Navbar';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import api from '../api';

function PendingTournaments() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem('JWTTOKEN');

  const getPendingData = async () => {
    try {
      const token = localStorage.getItem("JWTTOKEN");
      const res = await api.get("/v1/tournament/pending",{headers:{Authorization:`Bearer ${token}`}});
      const pendingTournaments = res.data.data.filter(t => t.status === "waiting");
      setData(pendingTournaments);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }
    getPendingData();
  }, []);

  return (
    <div className="app-container">
      <Navbar />
      <div className="main-content">
        <h2 style={{color: 'white', marginBottom: '30px'}}>Onay Bekleyen Turnuvalar</h2>
        
        <Row>
          {loading ? (
            <div style={{textAlign: 'center', width: '100%', marginTop: '50px'}}>
               <b style={{color: "white", fontSize: 20}}>Yükleniyor...</b>
            </div>
          ) : data && data.length > 0 ? data.map((i) => (
            <Col key={i._id} xs={12} md={6} lg={4} xl={3}>
              {/* Karta onClick vererek detay sayfasına yönlendiriyoruz */}
              <div 
                onClick={() => navigate(`/tournament-detail/${i._id}`)} 
                style={{ cursor: 'pointer', textDecoration: "none" }}
              >
                <Card style={{ backgroundColor: 'transparent', border: '1px solid #252525', transition: '0.3s' }} className='mt-3 rounded-4 overflow-hidden tournament-card'>
                  <Card.Img variant="top" src={i.image || 'https://via.placeholder.com/150'} style={{ height: '180px', objectFit: 'cover' }} />
                  <Card.Body style={{ backgroundColor: '#121212' }}>
                    <Card.Title style={{ color: "white", fontSize: '16px' }}>{i.title}</Card.Title>
                    <Card.Subtitle style={{ color: "#8b8b8b", fontSize: '13px' }} className='mt-2'>
                      Kategori: <b style={{color: 'white'}}>{i.category || 'Belirtilmedi'}</b> <br/>
                      Oluşturan: <b style={{color: 'white'}}>{i.createdBy || 'Anonim'}</b>
                    </Card.Subtitle>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          )) : (
            <div style={{textAlign: 'center', width: '100%', marginTop: '50px'}}>
               <b style={{color: "#8b8b8b", fontSize: 18}}>Şu an onay bekleyen bir turnuva bulunmuyor.</b>
            </div>
          )}
        </Row>
      </div>
    </div>
  );
}

export default PendingTournaments;